// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatWorkflowSkillDeletionPreviewDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatWorkflowSkillReferenceDtoGenShape } from "./chat-workflow-skill-reference-dto.gen";

export const ChatWorkflowSkillDeletionPreviewDtoGenShape = z.strictObject({
  skillDocumentId: z.string(),
  sidecarCount: z.number(),
  isLastVersion: z.boolean(),
  blockedBy: z.array(ChatWorkflowSkillReferenceDtoGenShape),
});
